// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast-container {
  position: fixed;
  top: 1.25rem;
  right: 1.25rem;
  z-index: 50;
  min-width: 30%;
  max-width: 80%;
  margin-right: 10px;
}

.toast {
  width: 100%;
  padding: 0px 10px;
  margin: 5px;
  margin-top: 1rem;
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px 0 rgba(148, 148, 148, 0.05);
  transition: transform 0.1s;
  transform: translateX(0);
}
.toast.success {
  background-color: #34d058;
  color: #ffffff;
}
.toast.error {
  background-color: #ef4444;
  color: #ffffff;
}
.toast.default {
  background-color: #3b82f6;
  color: #ffffff;
}

.toast-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.toast-message {
  padding: 1rem;
}

.toast-dismiss-button {
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  font-size: 1.25rem;
  color: #FFFFFF;
  transition: color 0.2s;
}
.toast-dismiss-button:hover {
  color: #000;
}`, "",{"version":3,"sources":["webpack://./src/common/toaster/index.scss","webpack://./src/scss/colors.scss"],"names":[],"mappings":"AAEA;EACI,eAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AADJ;;AAIE;EACE,WAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,iDAAA;EACA,0BAAA;EACA,wBAAA;AADJ;AAGI;EACE,yBAAA;EACA,cAAA;AADN;AAII;EACE,yBAAA;EACA,cAAA;AAFN;AAKI;EACE,yBAAA;EACA,cAAA;AAHN;;AAOE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAJJ;;AAOE;EACE,aAAA;AAJJ;;AAOE;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,cCtDS;EDuDT,sBAAA;AAJJ;AAMI;EACE,WAAA;AAJN","sourcesContent":["@import \"../../scss/colors.scss\";\n\n.toast-container {\n    position: fixed;\n    top: 1.25rem; \n    right: 1.25rem;\n    z-index: 50; \n    min-width: 30%;\n    max-width: 80%;\n    margin-right: 10px;\n  }\n  \n  .toast {\n    width: 100%;\n    padding: 0px 10px; \n    margin: 5px;\n    margin-top: 1rem; \n    border-radius: 0.5rem; \n    box-shadow: 0 1px 2px 0 rgba(148, 148, 148, 0.05);\n    transition: transform 0.1s; \n    transform: translateX(0); \n  \n    &.success {\n      background-color: #34d058; \n      color: #ffffff; \n    }\n  \n    &.error {\n      background-color: #ef4444; \n      color: #ffffff; \n    }\n  \n    &.default {\n      background-color: #3b82f6; \n      color: #ffffff; \n    }\n  }\n  \n  .toast-content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .toast-message {\n    padding: 1rem; \n  }\n  \n  .toast-dismiss-button {\n    cursor: pointer;\n    background: none;\n    border: none;\n    padding: 0;\n    font-size: 1.25rem; \n    color:$color-White; \n    transition: color 0.2s;\n  \n    &:hover {\n      color: #000;\n    }\n  }\n  \n  ","$color-White:#FFFFFF;\n$color-Secondary:#699BB6;\n\n$color-Gradient-1-2:#002F48;\n$color-Gradient-2-2:#FF6B6B;\n$color-Gradient-3-2:#987EE4;\n$color-Gradient-4-2:#F595DF; \n$color-Gradient-5-2:#FEA5A5;\n\n$color-Gradient-1-1:#216B93;\n$color-Gradient-2-1:#F595DF;\n$color-Gradient-3-1:#6D4ECB;\n$color-Gradient-4-1:#C465AE;\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
